var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
var DOWNLOAD_MSG;
(function (DOWNLOAD_MSG) {
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10000"] = 100] = "DOWNLOAD_MORE_10000";
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10001"] = 101] = "DOWNLOAD_MORE_10001";
    DOWNLOAD_MSG[DOWNLOAD_MSG["DOWNLOAD_MORE_10002"] = 102] = "DOWNLOAD_MORE_10002";
})(DOWNLOAD_MSG || (DOWNLOAD_MSG = {}));
var DownMessageTmpl = (function (_super) {
    __extends(DownMessageTmpl, _super);
    function DownMessageTmpl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.msgEnum = DOWNLOAD_MSG;
        _this.msgDetail = {};
        return _this;
    }
    DownMessageTmpl.prototype.created = function () {
        this.msgDetail = this.msgDetail;
    };
    DownMessageTmpl.prototype.close = function () {
        this.$emit('downLoad:ok');
        this.$closeDialog();
    };
    DownMessageTmpl.prototype.downLoad = function () {
        this.$emit('downLoad:ok');
        location.href = this.msgDetail.notice_params.download_url;
        this.$closeDialog();
    };
    DownMessageTmpl = __decorate([
        Component
    ], DownMessageTmpl);
    return DownMessageTmpl;
}(VueDialog));
export default DownMessageTmpl;
